





































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { ServiceRequestModel } from '../../types/request';
import { MapUtils } from '@/util/mapUtils';
import { ModelSelect } from 'vue-search-select';
import AddRxProviderModal from '../modal/AddRxProviderModal.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { RxProvider } from '@/types/entity';

declare var google: any;
@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        AddRxProviderModal,
        ModelSelect,
    },
    data() {
        return {
            rxProvidersOptions: [],
            phone: '',
        };
    },
    validations() {
        const validations = {
            serviceRequest: {
                facility: {
                    name: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        locality: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                },
                delivery: {
                    deliveryItems: {
                        required,
                    },
                    businessCloseTime: {
                        required,
                    },
                },
                cmr: {
                    healthInsuranceName: {
                        required,
                    },
                },
            },
            item: {
                minLength: minLength(2),
            },
            phone: {
                required,
                regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
        };
        if (this.$props.serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.facility;
            delete validations.serviceRequest.delivery;
            delete validations.item;
            delete validations.phone;
        } else {
            delete validations.serviceRequest.cmr;
        }
        return validations;
    },
})
export default class PickupDetails extends Vue {
    private facilityGoogleAddress: any;
    private item = '';
    private showAddRxProviderForm = false;
    private rxProviders: RxProvider[] = [];


    public mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.stops.isStop1Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT });
            return;
        }
        if (serviceRequest.delivery && !serviceRequest.delivery.isCmr) {
            this.facilityGoogleAddress = new google.maps.places.Autocomplete(this.$refs.facilityAddress,
            { types: ['geocode'] });
            this.facilityGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.facility.address = MapUtils.parseGoogleAddress(this.facilityGoogleAddress);
            });
            this.getRxProviderList();
        }
    }


    private validateTime() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery && serviceRequest.delivery.businessCloseTime) {
            let time = new Array();
            time = serviceRequest.delivery.businessCloseTime.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.delivery.businessCloseTime = '';
            }
        }
    }

    private showAddRxProvider() {
        this.showAddRxProviderForm = true;
    }

    private async getRxProviderList() {
        const response = await ObjectFactory.getRxProviderService()
            .getRxProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.rxProviders = response.data as any;
        this.$data.rxProvidersOptions = [];
        this.rxProviders.forEach((rxProvider) => {
            if (rxProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: rxProvider.fullname,
                    text: rxProvider.fullname,
                };
                this.$data.rxProvidersOptions.push(providersOption);
            }
        });
    }

    private copyRxProvider(fullname: string) {
        if (this.rxProviders) {
            this.rxProviders.forEach((rxProvider) => {
                if (rxProvider.fullname === fullname) {
                    if (rxProvider.address) {
                        this.$props.serviceRequest.facility.address = rxProvider.address;
                    } else {
                        this.$props.serviceRequest.facility.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.$props.serviceRequest.delivery.businessCloseTime = rxProvider.businessCloseTime ?
                    rxProvider.businessCloseTime : '';
                    this.$props.serviceRequest.facility.email = rxProvider.email ? rxProvider.email : '';
                    if (rxProvider.phone) {
                        this.$data.phone = rxProvider.phone.trim();
                        this.$props.serviceRequest.facility.phone = rxProvider.phone.trim();
                    }
                }
            });
        }
    }

    private nextStep() {
        this.$props.serviceRequest.stops.isStop2Valid = true;
        this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
    }

    private preStep() {
        this.$router.go(-1);
    }

    private addDeliveryItem() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery && this.item && !this.$v.item.$invalid) {
            const found = serviceRequest.delivery.deliveryItems.indexOf(this.item);
            if (found! < 0) {
                serviceRequest.delivery.deliveryItems.push(this.item);
            }
            this.item = '';
        }
    }

    private removeDeliveryItem(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.delivery) {
            serviceRequest.delivery.deliveryItems.splice(index, 1);
        }
    }
}
